<template>
  <div id="container">
    <el-form :inline="true" class="filter-container">
      <el-form-item label="餐厅">
        <el-select
          size="mini"
          class="filter-item"
          style="width: 150px"
          value-key="canteen_name"
          v-model="listQuery.canteen"
          placeholder="餐厅选择"
          @change="handleFilter">
        <el-option
          v-for="canteen in canteenList"
          :key="canteen.canteen_id"
          :label="canteen.canteen_name"
          :value="canteen">
        </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
          size="mini"
          class="filter-item"
          :clearable="false"
          style="width: 150px"
          v-model="listQuery.date"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @change="handleFilter"
        >
      </el-date-picker>
      </el-form-item>
      <el-form-item label="餐时">
        <el-select
          class="filter-item"
          size="mini"
          style="width: 150px"
          v-model="listQuery.meal"
          placeholder="请选择"
        >
        <el-option
          v-for="item in mealOptions"
          :key="item.index"
          :label="item.type"
          :value="item.index"
        >
        </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          size="mini"
          class="filter-item"
          style="width: 150px"
          v-model="listQuery.type"
          placeholder="请选择"
        >
        <el-option
          v-for="item in specialOptionsExtends"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      </el-form-item>
      <el-form-item>
        <el-badge class="mark" :value="searchedFoodList.length">
        <el-tag type="success">菜单总数 </el-tag>
      </el-badge>
      </el-form-item>
      <br>
      <el-form-item>
        <el-button
          size="mini"
          @click="downloadExcelModel"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
        >下载excel 模板</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          @click="downloadExcelModel2"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
        >下载excel 模板(营养)</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          ref="uploadNormal"
          action=""
          :http-request="uploadExcel"
          class="filter-item"
        >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-upload"
          class="filter-item"
          v-loading.fullscreen.lock="fullscreenLoading"
        >上传excel(一般)
        </el-button>
      </el-upload>
      </el-form-item>
      <el-form-item>
        <el-upload
          ref="uploadNutrition"
          class="filter-item"
          action=""
          :http-request="uploadExcelNew"
        >
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-upload"
          class="filter-item"
          v-loading.fullscreen.lock="fullscreenLoading"
        >上传excel(营养)
        </el-button>
      </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          v-show="addButtonShow"
          class="filter-item"
          type="danger"
          v-waves
          icon="el-icon-delete"
          @click="deleteMenus"
        >删除本页菜单
      </el-button>
      </el-form-item>
      <el-form-item>
        <el-input
          class="filter-item search-box"
          size="mini"
          v-model="listQuery.search"
          placeholder="搜索菜品"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="table-container" ref="table">
      <div :class="btnFixed ? 'btn-wrapper-fixed' : 'btn-wrapper'" ref="btn">
        <el-button
          type="success"
          icon="el-icon-plus"
          circle
          @click="addItem"
        ></el-button>
      </div>
      <el-table
        ref="menuTable"
        class="menu-table"
        @header-click="headerClick"
        :data="searchedFoodList"
        border
        fit
        style="width:100%;text-align: center;"
        center="all"
        @selection-change="handleSelectionChange"
      >
        <!--<el-table-column style="display: none" align="center" width="50" type='selection'>-->
        <!--</el-table-column>-->
        <el-table-column
          align="center"
          prop="food_name"
          label="菜名"
          class-name="strong-text"
        >
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="
                currentRow !== null && scope.$index === currentRow && isEdit
              "
              v-model="currentMenu.food_name"
              placeholder="请输入菜名"
            ></el-input>
            <el-autocomplete
              :trigger-on-focus="false"
              v-if="
                currentRow !== null && scope.$index === currentRow && !isEdit
              "
              v-model="currentMenu.food_name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
              @change.native="handleChange"
            ></el-autocomplete>
            <span v-if="currentRow === null || scope.$index !== currentRow">{{
              scope.row.food_name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="例图">
          <template slot-scope="scope">
            <div v-if="getImage(scope.row.uuid).length > 0">
              <el-popover
                v-for="img in getImage(scope.row.uuid)"
                :key="img"
                ref="popover1"
                placement="top-start"
                trigger="hover"
              >
                <img alt="" width="150" :src="img" />
                <span class="image-wrapper" slot="reference">
                  <img class="image-item" :src="img" alt=""  />
                </span>
              </el-popover>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="currentRow !== null && scope.$index === currentRow"
              v-model="currentMenu.food_price"
              placeholder="请输入价格"
            ></el-input>
            <span v-else>{{ scope.row.food_price || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <!--<span>{{ scope.row.food_special }}</span>-->
            <el-select
              size="mini"
              v-model="currentMenu.food_special"
              v-if="currentRow !== null && scope.$index === currentRow"
              placeholder="请选择"
            >
              <el-option
                v-for="special in specialOptionsExtends.slice(1)"
                :key="special"
                :label="special"
                :value="special">
              </el-option>
            </el-select>
            <span v-else>{{ scope.row.food_special }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="餐时">
          <template slot-scope="scope">
            <el-select
              size="mini"
              v-model="currentMenu.food_type"
              v-if="currentRow !== null && scope.$index === currentRow"
              placeholder="请选择"
            >
              <el-option
                v-for="meal in mealOptions.slice(1)"
                :key="meal.index"
                :label="meal.type"
                :value="meal.index"
              >
              </el-option>
            </el-select>
            <span v-else>{{
              typeOptions[scope.row.food_type - 1].type || scope.row.food_type
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="常驻" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="currentRow !== null && scope.$index === currentRow"
              class="btn btn-mine"
              @click="setPermanent(scope)"
              type="text"
            >
              <i
                v-if="currentMenu.permanent === '1'"
                class=" icon el-icon-check  icon-weight"
              ></i>
              <i v-else class="el-icon-close icon"></i>
            </el-button>
            <el-button
              v-else
              class="btn btn-mine"
              @click="setPermanent(scope)"
              type="text"
            >
              <i
                v-if="scope.row.permanent === '1'"
                class=" icon el-icon-check  icon-weight"
              ></i>
              <i v-else class="el-icon-close icon"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="nutrition.calorie_c"
          label="卡路里"
          width="100"
          header-align="center"
        >
          <template slot-scope="scope">
            <span v-if="currentRow !== null && scope.$index === currentRow">{{
              currentMenu.nutrition.calorie_c || 0
            }}</span>
            <span v-else>{{ scope.row.nutrition.calorie_c || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nutritionDetailShow"
          label="纤维素"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="currentRow !== null && scope.$index === currentRow">{{
              currentMenu.nutrition.fibrin_g || 0
            }}</span>
            <span v-else>{{ scope.row.nutrition.fibrin_g || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nutritionDetailShow"
          label="糖类"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="currentRow !== null && scope.$index === currentRow">{{
              currentMenu.nutrition.carbohydrate_g || 0
            }}</span>
            <span v-else>{{ scope.row.nutrition.carbohydrate_g || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nutritionDetailShow"
          label="脂肪"
          width="50"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="currentRow !== null && scope.$index === currentRow">{{
              currentMenu.nutrition.fat_g || 0
            }}</span>
            <span v-else>{{ scope.row.nutrition.fat_g || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="nutritionDetailShow"
          label="蛋白质"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="currentRow !== null && scope.$index === currentRow">{{
              currentMenu.nutrition.protein_g || 0
            }}</span>
            <span v-else>{{ scope.row.nutrition.protein_g || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <span v-if="currentRow !== null && currentRow === scope.$index">
              <el-button size="mini" @click="upload(scope.row)" type="success"
                >确定</el-button
              >
              <el-button size="mini" @click="cancelAdd(scope)" type="danger"
                >取消</el-button
              >
            </span>
            <span v-else>
              <!--<el-button-->
              <!--slot="reference"-->
              <!--@click="editNutrition(scope)"-->
              <!--type="text"-->
              <!--size="small"-->
              <!--&gt;智能矫正营养信息-->
              <!--</el-button>-->
              <!--<br />-->
              <el-button @click="handleEdit(scope)" type="text" size="small"
                >编辑</el-button
              >
              <el-button
                @click="handleDelete(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :center="true"
      title="导入菜单结果"
      :visible.sync="toggleModal"
      width="50%"
      :before-close="closeSuccessModal"
    >
      <h3 class="title">您成功导入{{ gridData.length }}天的菜单</h3>
      <el-table
        height="200"
        border
        fit
        style="width:100%;text-align: center;"
        :data="gridData"
        center="all"
      >
        <el-table-column
          property="date"
          label="日期"
          align="center"
        ></el-table-column>
        <el-table-column
          property="count"
          label="菜单数量"
          align="center"
        ></el-table-column>
      </el-table>
      <h3 class="sub-title" v-if="failDate.length > 0">
        请注意, 有{{ failDate.length }}个表单页(sheet)解析异常:
        <span v-for="date in failDate" :key="date">{{ date }}, </span>
      </h3>
      <div v-show="foodNutritionError.length > 0">
        <h3 class="title">以下菜品营养信息获取失败</h3>
        <el-table
          height="200"
          border
          fit
          style="width:100%;text-align: center;"
          :data="foodNutritionError"
          center="all"
        >
          <el-table-column
            property="datetime"
            label="日期"
            align="center"
          ></el-table-column>
          <el-table-column
            property="food_name"
            label="菜名"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSuccessModal">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="duplicateModal" title="提示" width="50%">
      <h3 class="title">当前excel有以下数据和云端重复, 是否合并?</h3>
      <el-table :data="duplicateFoods" height="250" border style="width: 100%">
        <el-table-column
          property="datetime"
          label="日期"
          align="center"
        ></el-table-column>
        <el-table-column
          property="food_name"
          label="菜名"
          align="center"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelCombine">取消</el-button>
        <el-button type="success" @click="combineFoods">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="noCanteen" title="提示" width="50%">
      <span>请注意, 当前食堂没有餐厅!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noCanteen = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="popoverShow" title="请选择营养信息" width="500">
      <el-table :data="nutritionList" max-height="300">
        <el-table-column
          header-align="center"
          align="center"
          property="name"
          label="名字"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          property="nutrition.calorie_c"
          label="卡路里"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="selectItem(scope.row)" type="text" size="small"
              >选定</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
import waves from '@/directive/waves' // 水波纹指令
import UUID from 'uuid-js'
import util from '../util/util'
import pinyinMatch from 'pinyin-match'
import {
  apiUploadExcel,
  apiMenuBatchAdd,
  apiUploadExcelNutrition,
  apiSetPermanent,
  apiGetMenuByDate,
  apiDeleteMenus,
  apiQueryCalorieByFoodName,
  apiQueryCalorieByFoodNameCalorieMode,
  apiMenuBatchUpdate,
  apiMenuAdd,
  apiMenuDelete,
  apiMenuImgQueryByfoodUuidList,
  apiFoodQueryByName,
  apiMenuUpdate
} from '@/api'
import { aliUpload } from '@/util/aliOssUpload'

const OSS = require('ali-oss')
function formateCal (cal) {
  console.log(cal)
  if (cal <= 200) {
    return Math.floor(cal)
  } else {
    let random = Math.random() * 20 + 180
    return Math.floor(random)
  }
}
function isEmptyObj (obj) {
  for (const key in obj) {
    return false
  }
  return true
}

export default {
  name: 'menuManage',
  directives: {
    waves
  },
  components: {},
  data () {
    return {
      isAdd: false,
      isEdit: false,
      menu_img_dic: {},
      btnFixed: false,
      selectedFood: [],
      popoverShow: false,
      nutritionList: [],
      nutritionDetailShow: false,
      duplicateFoods: [],
      duplicateModal: false,
      failDate: [],
      fullscreenLoading: true,
      foodNutritionError: [],
      noCanteen: false,
      gridData: [],
      foodFromExcel: {},
      toggleModal: false,
      viewportHight: 0,
      listQuery: {
        page: 1,
        limit: 20,
        canteen: {},
        meal: -1, // food_type
        date: util.formateDate(new Date()),
        type: '全部', // food_spicel
        sort: '+id',
        search: ''
      },
      rules: {
        food_name: [
          { required: true, message: '请输入菜品名称', trigger: 'blur' }
        ],
        food_price: [
          { required: true, message: '请输入菜品价格', trigger: 'blur' },
          { type: 'number', message: '价格必须为数字', trigger: 'blur' }
        ],
        food_special: [{ required: true, trigger: 'blur' }],
        food_type: [{ required: true, trigger: 'blur' }]
      },
      specialOptions: ['全部', '大荤', '小荤', '素', '汤', '主食'],
      typeOptions: [
        { index: 1, type: '早餐' },
        { index: 2, type: '午餐' },
        { index: 3, type: '晚餐' }
      ],
      mealOptions: [
        { index: -1, type: '全部' },
        { index: 1, type: '早餐' },
        { index: 2, type: '午餐' },
        { index: 3, type: '晚餐' }
      ],
      dialogTableVisible: false,
      defaultMenu: {
        uuid: '',
        datetime: '',
        food_name: '',
        food_price: '',
        food_special: '未设置',
        food_type: 1,
        permanent: '0',
        nutrition: {
          fibrin_g: '',
          carbohydrate_g: '',
          fat_g: '',
          calorie_c: '',
          protein_g: ''
        }
      },
      currentRow: null,
      currentMenu: {},
      listLoading: true,
      inputColumn: null,
      menuList: [],
      list: [],
      formLabelWidth: '120px'
      // for component ImageGallery
    }
  },
  mounted () {
    this.currentMenu = _.cloneDeep(this.defaultMenu)

    this.listQuery.canteen = this.canteenList[0]
    this.handleFilter()
    // this.getMachineList()
    this.$nextTick(() => {
      this.viewportHight = document.documentElement.clientHeight
    })
    window.onresize = () => {
      this.$nextTick(() => {
        this.viewportHight = document.documentElement.clientHeight
        console.log(this.viewportHight)
      })
    }
  },
  computed: {
    canteenList () {
      return this.$store.getters.canteenList()
    },
    menuListByFilter () {
      const { meal, type } = this.listQuery
      return this.$_.filter(this.menuList, { food_type: meal, food_special: type })
    },
    food_uuid_list () {
      return this.menuList.map(a => a.uuid)
    },
    specialOptionsExtends () {
      const extendOptions = _.uniq(
        this.menuList.map(a =>
          a.food_special === '' ? '未设置' : a.food_special
        )
      )
      return _.uniq([...this.specialOptions, ...extendOptions])
    },
    userinfo () {
      return this.$store.getters.userinfo()
    },
    api_key () {
      return this.userinfo.api_key
    },
    searchedFoodList () {
      let menuList = this.$_.cloneDeep(this.menuList)
      let search = this.listQuery.search
      let list = menuList
      if (this.listQuery.type !== '全部') {
        list = list.filter(a => a.food_special === this.listQuery.type)
      }
      if (this.listQuery.meal !== -1) {
        list = list.filter(a => a.food_type === this.listQuery.meal)
      }
      if (search !== '') {
        list = list.filter(menu => {
          let res = []
          res = pinyinMatch.match(menu['food_name'], search)
          return res.length > 0
        })
      }
      if (this.isAdd) {
        return [...list, this.currentMenu]
      } else {
        return list
      }
    },
    calorieMode () {
      return this.userinfo.username === 'tryydemo'
    },
    // uploadButtonShow() {
    //   if (isEmptyObj(this.listQuery.canteen)) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    addButtonShow () {
      return this.listQuery.canteen.canteen_id !== undefined
    }
  },
  methods: {
    getImage (uuid) {
      if (this.menu_img_dic.hasOwnProperty(uuid)) {
        return this.menu_img_dic[uuid]
      } else {
        return []
      }
    },
    handleChange () {
      console.log('saaaaaaaaaaaaaaaaaaaaaaa')
      this.currentMenu.food_uuid = ''
    },
    handleSelect (item) {
      // console.log(`sadddddddddddddd`, item);
      const { food } = item
      this.currentMenu = food
    },
    addItem (row) {
      if (this.isEdit || this.isAdd) {
        return this.$message.error('请完善当前菜品信息')
      }
      // this.currentMenu = _.cloneDeep(this.defaultMenu)
      // this.menuList.push(this.currentMenu)

      this.isAdd = true
      this.currentMenu = _.cloneDeep(this.defaultMenu)
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight)
      })
      this.currentRow = this.searchedFoodList.length - 1
    },
    cancelAdd (scope) {
      this.isEdit = false
      this.isAdd = false
      this.currentMenu = null
      this.currentRow = null
    },
    sortByPermanent (list) {
      list.sort(function (a, b) {
        return b.permanent - a.permanent
      })
      return list
    },
    async setPermanent (scope) {
      if (this.currentRow === scope.$index) {
        this.currentMenu.permanent =
          this.currentMenu.permanent === '0' ? '1' : '0'
        return
      }
      let row = scope.row
      try {
        await apiSetPermanent({
          canteen_id: this.listQuery.canteen.canteen_id,
          food_uuid: row.uuid,
          food_permanent: row.permanent === '0' ? '1' : '0'
        })
        row.permanent = row.permanent === '0' ? '1' : '0'
        if (row.permanent === 0 || row.permanent === '0') {
          this.handleFilter()
        }
      } catch (e) {
        this.$message.error('操作失败' + e.message)
      }
    },
    handleSelectionChange (rows) {
      this.selectedFood = rows
    },
    selectItem (row) {
      this.currentMenu.nutrition = row.nutrition
      if (this.dialogTableVisible || this.currentRow !== null) {
        this.popoverShow = false
        return
      }
      this.upload()
      this.popoverShow = false
    },
    beforeAdd () {},
    async querySearchAsync (name, cb) {
      try {
        const { food_info_list } = await apiFoodQueryByName(name)
        // console.log(res);
        food_info_list.forEach(a => {
          a.food_price = a.food_price / 100
        })
        const res = food_info_list.map(a => {
          return {
            value: a.food_name + ' ' + a.food_price + '元',
            food: a
          }
        })
        cb(res)
      } catch (e) {}
    },
    async findByName (scope) {
      if (scope.row && scope.row.food_name !== undefined) {
        this.currentMenu = scope.row
      }
      try {
        const res = await apiFoodQueryByName(this.currentMenu.food_name)
        this.$message.success('查询成功' + res)
      } catch (e) {
        this.$message.error('查询失败' + e.message)
      }
    },
    async editNutrition (scope) {
      if (scope.row && scope.row.food_name !== undefined) {
        this.currentMenu = scope.row
      }
      if (this.calorieMode === true) {
        try {
          const res = await apiQueryCalorieByFoodNameCalorieMode({
            canteen_id: this.listQuery.canteen.canteen_id,
            flag: '',
            food_name: this.currentMenu.food_name.trim()
          })
          this.fullscreenLoading = false
          this.popoverShow = true
          this.nutritionList = res.nutrition
        } catch (e) {
          this.$message.error('营养信息查询失败,没有此种菜品的营养信息')
          this.fullscreenLoading = false
          // this.nutritionList = [res.body.data.nutrition]
          this.currentMenu.nutrition.calorie_c = 0
        }
      } else {
        try {
          let { data } = await apiQueryCalorieByFoodName(
            this.currentMenu.food_name.trim()
          )
          data = data.map(food => {
            food.nutrition.calorie_c = formateCal(food.nutrition.calorie_c)
            return food
          })
          this.fullscreenLoading = false
          this.popoverShow = true
          this.nutritionList = data
        } catch (e) {
          console.log(e)
          this.fullscreenLoading = false
          this.$message.error('查询菜品营养信息失败, 请检查名字重试')
        }
      }
    },
    headerClick (col, e) {
      if (col.label === '卡路里') {
        this.nutritionDetailShow = !this.nutritionDetailShow
      }
      console.log(col, e)
    },
    cancelCombine () {
      this.duplicateModal = false
      this.handleFilter()
    },
    async combineFoods () {
      this.duplicateModal = false
      this.fullscreenLoading = true
      try {
        await apiMenuBatchUpdate(
          this.duplicateFoods,
          this.listQuery.canteen.canteen_id.toString()
        )
        this.toggleModal = true
        this.fullscreenLoading = false
      } catch (e) {
        this.toggleModal = true
        this.fullscreenLoading = false
        this.$message.error('合并失败' + e.message)
      }
    },
    closeSuccessModal () {
      if (this.failDate && this.failDate.length > 0) {
        this.$alert(
          `<h2 style="color: red">请注意,${
            this.failDate[0]
          }等表页解析异常, 请检查表页信息是否正确!!!</h2>`,
          '!!重要提示!!',
          {
            type: 'error',
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
              this.fullscreenLoading = false
              this.toggleModal = false
              this.foodNutritionError = []
              this.handleFilter()
            }
          }
        )
      } else {
        this.fullscreenLoading = false
        this.$refs['uploadNormal'].clearFiles()
        this.$refs['uploadNutrition'].clearFiles()
        this.toggleModal = false
        this.foodNutritionError = []
        this.handleFilter()
      }
    },
    canteenCount () {
      if (this.canteenList.length <= 0) {
        this.noCanteen = true
      } else {
        this.noCanteen = false
      }
    },
    testForm () {
      if (isEmptyObj(this.listQuery.canteen)) {
        this.$alert('请选择您要上传带单的餐厅', '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    createOssClient () {
      let options = {
        region: 'oss-cn-shanghai',
        accessKeyId: 'LTAI5t6aZ1HvhPVCDkgyr6k7',
        accessKeySecret: 'PTISVsF968AUyeBzEoYhOpMVR658EH',
        bucket: 'menu-excels'
      }
      this.client = new OSS(options)
    },
    downloadExcelModel () {
      let loadingInstance = this.$loading({
        fullscreen: true
      })
      this.createOssClient()
      let file_path = '/model/智眼金睛菜品识别周菜单上传标准模板.xlsx'
      let url = this.client.signatureUrl(
        file_path,
        {
          expires: 3600
        }
      )
      window.open(url)
      this.$nextTick(() => {
        loadingInstance.close()
      })
    },
    downloadExcelModel2 () {
      let loadingInstance = this.$loading({
        fullscreen: true
      })
      this.createOssClient()
      let file_path = '/model/智眼金睛菜品识别周菜单上传标准模板(营养).xlsx'
      let url = this.client.signatureUrl(
        file_path,
        {
          expires: 3600
        }
      )
      window.open(url)
      this.$nextTick(() => {
        loadingInstance.close()
      })
    },
    uploadExcel (options) {
      let file = options.file
      let fileName = options.file.name.split('.')[0]
      let fileType = options.file.name.split('.')[1]
      let storeAs = fileName + new Date().getTime() + '.' + fileType
      this.createOssClient()
      this.fullscreenLoading = true
      this.client
        .put(storeAs, file)
        .then(async result => {
          try {
            let url = result.res.requestUrls[0].split('?')[0]
            const res = await apiUploadExcel(url)
            let { foods, fail_date, date_food_num } = res
            console.log(foods)
            this.gridData = date_food_num
            this.failDate = fail_date
            for (let food of foods) {
              console.log(food)
              food.food_name = food.food_name.replace(/\s*/g, '')
              food.food_price = !food.food_price
                ? 0
                : Number(food.food_price.toString().replace(/%s/g, ''))
              try {
                const res = await apiQueryCalorieByFoodName(food.food_name)
                console.log(res)
                let nutritions = res[0].nutritions
                nutritions.calorie_c = formateCal(nutritions.calorie_c)
                //               console.log(nutrition.calorie_c)
                food.nutrition = nutritions
              } catch (e) {
                food.nutrition = {
                  calorie_c: 0,
                  carbohydrate_g: 0,
                  fat_g: 0,
                  fibrin_g: 0,
                  protein_g: 0
                }
                this.foodNutritionError.push(food)
              }
            }
            try {
              const res = await apiMenuBatchAdd(
                foods,
                this.listQuery.canteen.canteen_id.toString()
              )
              if (res.state_code === 0) {
                this.handleFilter()
                this.toggleModal = true
                this.handleFilter()
                this.$refs['uploadNormal'].clearFiles()
                this.$refs['uploadNutrition'].clearFiles()
                // console.log(this.$refs['upload']);
              } else if (res.state_code === -2) {
                this.duplicateModal = true
                this.duplicateFoods = res.duplicate_foods || []
                this.handleFilter()
                // console.log(this.$refs['upload']);
                this.$refs['uploadNormal'].clearFiles()
                this.$refs['uploadNutrition'].clearFiles()
              } else {
                throw new Error(res.error_msg)
              }
            } catch (e) {
              this.fullscreenLoading = false
              this.$refs['uploadNormal'].clearFiles()
              this.$refs['uploadNutrition'].clearFiles()
              this.$message.error('菜单上传失败' + e.message)
            }
          } catch (e) {
            this.fullscreenLoading = false
            this.$refs['uploadNormal'].clearFiles()
            this.$refs['uploadNutrition'].clearFiles()
            this.$message.error(
              'excel表格格式有误，解析失败，请重试！' + e.message
            )
          }
        })
        .catch(e => {
          console.log(e)
          this.$refs['uploadNormal'].clearFiles()
          this.$refs['uploadNutrition'].clearFiles()
          this.fullscreenLoading = false
          this.$message.error('excel上传OSS失败,请重试！' + e.message)
        })
    },
    async uploadExcelNew (options) {
      const { file } = options
      this.fullscreenLoading = true
      if (!file) {
        return this.$message.error('未选择文件!')
      }
      try {
        let { url } = await aliUpload(
          {
            bucket: 'menu-excels'
          },
          file
        )
        try {
          const data = await apiUploadExcelNutrition(
            url,
            this.listQuery.canteen.canteen_id.toString()
          )
          let nutritionKeys = [
            'carbohydrate_g',
            'fat_g',
            'protein_g',
            'calorie_c'
          ]
          let { foods } = data
          foods = foods.map(a => {
            let nutritions = this.$_.pick(a, nutritionKeys)
            let b = this.$_.omit(a, nutritionKeys)
            this.$set(b, 'nutrition', nutritions)
            // console.log(a);
            return b
          })
          this.gridData = data.date_food_num
          this.failDate = data.fail_date
          // console.log(foods)
          try {
            const r = await apiMenuBatchAdd(
              foods,
              this.listQuery.canteen.canteen_id.toString()
            )
            console.log(r)
            if (r.state_code === 0) {
              this.handleFilter()
              this.toggleModal = true
              this.fullscreenLoading = false
              this.$refs['uploadNormal'].clearFiles()
              this.$refs['uploadNutrition'].clearFiles()
            } else if (r.state_code === -2) {
              this.fullscreenLoading = false
              this.duplicateModal = true
              this.duplicateFoods = r.duplicate_foods || []
              this.$refs['uploadNormal'].clearFiles()
              this.$refs['uploadNutrition'].clearFiles()
            } else {
              this.fullscreenLoading = false
              this.$refs['uploadNormal'].clearFiles()
              this.$refs['uploadNutrition'].clearFiles()
              this.$message.error('添加失败' + r.error_msg)
            }
          } catch (e) {
            console.log(e)
            this.fullscreenLoading = false
            this.$refs['uploadNormal'].clearFiles()
            this.$refs['uploadNutrition'].clearFiles()
            this.$message.error('添加失败' + e.message)
          }
        } catch (e) {
          console.log(e)
          this.fullscreenLoading = false
          this.$message.error('菜单解析失败, ' + e.message)
          this.$refs['uploadNormal'].clearFiles()
          this.$refs['uploadNutrition'].clearFiles()
        }
      } catch (e) {
        console.log(e)
        this.fullscreenLoading = false
        this.$refs['uploadNormal'].clearFiles()
        this.$refs['uploadNutrition'].clearFiles()
        this.$message.error('excel上传至阿里云失败, 请检查上传信息')
      }
    },
    handleEdit (scope) {
      // this.dialogTableVisible = true
      // this.currentMenu = row.uuid !== undefined ? row : this.currentMenu
      if (this.isEdit || this.isAdd) {
        return this.$message.error('请完善当前菜品信息')
      }
      this.currentRow = scope.$index
      this.isEdit = true
      this.currentMenu = _.cloneDeep(scope.row)
    },
    async upload () {
      if (
        this.currentMenu.food_name === '' ||
        this.currentMenu.food_price === '' ||
        !this.currentMenu.food_type ||
        !this.currentMenu.food_special
      ) {
        return this.$message.error('请完善菜品信息再上传')
      }
      this.currentMenu.datetime = this.listQuery.date.slice(0, 10)
      this.currentMenu.uuid ||
        (this.currentMenu.uuid = UUID.create().toString())
      this.currentMenu.food_price = Number.parseFloat(
        this.currentMenu.food_price
      )
      if (this.isAdd) {
        // 添加逻辑
        if (
          this.$_.find(this.menuList, a => {
            return (
              a.food_name === this.currentMenu.food_name &&
              a.food_type.toString() === this.currentMenu.food_type.toString()
            )
          })
        ) {
          return this.$message.error('当前当餐菜单中包含有此菜品, 请勿重复添加')
        }
        try {
          await apiMenuAdd(
            this.currentMenu,
            this.listQuery.canteen.canteen_id.toString()
          )
          this.currentMenu = _.cloneDeep(this.defaultMenu)
          this.$message.success('添加成功')
          this.handleFilter()
          this.isAdd = false
          this.currentRow = null
        } catch (e) {
          this.currentMenu = _.cloneDeep(this.defaultMenu)
          this.$message.error('添加失败' + e.message)
          this.currentRow = null
          this.isAdd = false
          this.handleFilter()
        }
      } else if (this.isEdit) {
        // 修改逻辑
        try {
          await apiMenuUpdate(
            this.currentMenu,
            this.listQuery.canteen.canteen_id.toString()
          )
          this.currentMenu = _.cloneDeep(this.defaultMenu)
          this.$message.success('修改成功')
          this.handleFilter()
          this.isEdit = false
          this.currentRow = null
        } catch (e) {
          this.isEdit = false
          this.currentMenu = _.cloneDeep(this.defaultMenu)
          console.log(e)
          this.$message.error('修改失败' + e.message)
          this.currentRow = null
          this.handleFilter()
        }
      }
    },
    handleUpload () {
      this.$refs.ruleFrom.validate(valid => {
        if (valid) {
          this.upload()
          this.dialogTableVisible = false
          this.$refs.ruleFrom.resetFields()
        } else {
          return false
        }
      })
    },

    handleDelete (row) {
      this.$alert('确定删除此菜品？', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      })
        .then(async () => {
          this.fullscreenLoading = true
          try {
            await apiMenuDelete(
              {
                uuid: row.uuid.toString(),
                date: this.listQuery.date.slice(0, 10),
                food_type: row.food_type
              },
              this.listQuery.canteen.canteen_id.toString()
            )
            this.handleFilter()
            this.fullscreenLoading = false
            this.$message.success('删除成功')
          } catch (e) {
            this.handleFilter()
            this.fullscreenLoading = false
            this.$message.error('删除失败' + e.message)
          }
        })
        .catch(action => {
          this.$message({
            type: 'error',
            message: '您已取消删除'
          })
        })
    },
    handleCancel () {
      this.currentMenu = _.cloneDeep(this.defaultMenu)
      this.dialogTableVisible = false
      this.handleFilter()
    },
    // 上传菜单
    // async getCanteenList() {
    //   // console.log(res);
    //   // this.$http
    //   //   .get(
    //   //     `${this._host}canteen/list/`,
    //   //     {
    //   //       headers: {
    //   //         'api-key': this.api_key,
    //   //         'Content-Type': 'application/x-www-form-urlencoded'
    //   //       }
    //   //     },
    //   //     { emulateJSON: true }
    //   //   )
    //   //   .then(res => {
    //   //     this.canteenList = res.body.data.canteen
    //   //     if (this.canteenList.length > 0) {
    //   //       this.listQuery.canteen = this.canteenList[0]
    //   //     }
    //   //     this.canteenCount()
    //   //   })
    //   //   .catch(e => {
    //   //     console.log(e)
    //   //     this.listLoading = false
    //   //     this.$message({
    //   //       message: '获取餐厅列表失败',
    //   //       type: 'error'
    //   //     })
    //   //   })
    // },
    deleteMenus () {
      this.$confirm('确定删除本页所有菜单？', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      })
        .then(async () => {
          this.fullscreenLoading = true
          try {
            await apiDeleteMenus(
              {
                date: this.listQuery.date.slice(0, 10).toString(),
                meal: this.listQuery.meal,
                special: this.listQuery.type
              },
              this.listQuery.canteen.canteen_id.toString()
            )
            this.$message.success('删除成功')
            this.handleFilter()
          } catch (e) {
            this.fullscreenLoading = false
            this.$message.error('删除失败' + e.message)
          }
        })
        .catch(action => {
          this.$message({
            type: 'warning',
            message: '您已取消删除'
          })
        })
    },
    async getFoodImageByUuidList () {
      try {
        const { menu_img_dic } = await apiMenuImgQueryByfoodUuidList(
          this.food_uuid_list
        )
        this.menu_img_dic = menu_img_dic
      } catch (e) {
        this.$message.error('查询例图失败' + e.message)
      }
    },
    async handleFilter () {
      this.fullscreenLoading = true
      this.currentMenu = null
      this.isAdd = false
      this.isEdit = false
      this.currentRow = null
      try {
        const res = await apiGetMenuByDate(
          {
            date: this.listQuery.date.slice(0, 10),
            meal: -1,
            special: -1
          },
          this.listQuery.canteen.canteen_id.toString()
        )
        this.menuList = this.sortByPermanent(res) || []
        this.menuList.forEach(a => {
          _.isEmpty(a.food_special) && (a.food_special = '未设置')
        })
        this.fullscreenLoading = false
        this.listLoading = false
        let table = this.$refs['table']
        let btn = this.$refs['btn']
        this.$nextTick(() => {
          let tableHieght = table.clientHeight
          this.viewportHight = document.documentElement.clientHeight
          if (tableHieght < this.viewportHight - 180) {
            btn.style.top = 100 + table.clientHeight + 'px'
            this.btnFixed = false
          } else {
            this.btnFixed = true
          }
        })
      } catch (e) {
        console.log(e)
        this.fullscreenLoading = false
        this.$message.error('查询菜单失败' + e.message)
      }
    }
  },
  watch: {
    listQuery: {
      handler (val) {
        this.currentMenu = null
        this.isAdd = false
        this.isEdit = false
        this.currentRow = null
      },
      deep: true
    },
    food_uuid_list: {
      handler () {
        this.getFoodImageByUuidList()
      },
      deep: true
    },
    canteenList: {
      handler () {
        if (this.canteenList.length > 0) {
          this.listQuery.canteen = this.canteenList[0]
          this.handleFilter()
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
#container {
  .filter-container {
    padding-top: 10px;
    .filter-item {
      display: inline-block;
    }
    .current-sum {
      padding-top: 10px;
      display: inline-block;
    }
  }
}
td.strong-text {
  font-size: 14px;
  font-weight: bold;
}

.title {
  text-align: center;
}
.sub-title {
  color: red;
  text-align: center;
}
.el-upload-list__item-name {
  display: none !important;
}
.table-container {
  .btn-wrapper {
    z-index: 100;
    position: absolute;
    right: 20px;
    /*bottom: 0;*/
    top: 200px;
  }
  .btn-wrapper-fixed {
    position: fixed;
    bottom: 40px;
    right: 20px;
  }
}
.menu-table {
  .btn {
    padding: 0;
    display: inline-block;
    border: #b9a3c4 1px solid;
    .icon {
      font-size: 20px;
      font-weight: 800;
      color: #50c28b;
      &.el-icon-close {
        color: #fff;
      }
    }
  }
}
.image-wrapper {
  display: inline-block;
  width: 50px;
  height: 50px;
  .image-item {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
